'use client';

import { Suspense, useState } from 'react';

import LoginModal from '@/widgets/LoginModal';

import { isUserLogin } from '@/utilities/CheckUserIsLogin';

import { CAMPAIGN_PRODUCTS_SECTION_ID, CAMPAIGN_REWARD_SECTION_ID } from '@/constants/batteryToBattery';

import BatteryProducts from '../BatteryProducts';
import CouponReminder from '../CouponReminder';
import FinalCta from '../FinalCta';
import Hero from '../Hero';
import HowItWorks from '../HowItWorks';
import InquiryTouchPoints from '../InquiryTouchPoints';
import MarqueeStrip from '../MarqueeStrip';
import Reveal from '../Reveal';
import RewardCard from '../RewardCard';
import SparePartsProducts from '../SparePartsProducts';
import StickyMobileCta from '../StickyMobileCta';
import WhyAzki from '../WhyAzki';

import { cornbar } from 'cornbar';

const scrollToCampaignSection = (id: string) => {
    if (typeof document !== 'undefined') {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};

const CampaignLanding = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => Boolean(isUserLogin()));
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const scrollToReward = () => scrollToCampaignSection(CAMPAIGN_REWARD_SECTION_ID);
    const scrollToProducts = () => scrollToCampaignSection(CAMPAIGN_PRODUCTS_SECTION_ID);

    const handleCtaClick = () => {
        if (isUserLogin()) {
            setIsLoggedIn(true);
            scrollToReward();
            return;
        }
        setIsLoginModalOpen(true);
    };

    const handleUserLogin = () => {
        setIsLoginModalOpen(false);
        setIsLoggedIn(true);
        cornbar.show({
            title: 'کد تخفیفت آماده است!',
            description: 'شما میتوانید در سفارش خود از این کد تخفیف استفاده کنید.',
            variant: 'success'
        });
        setTimeout(scrollToReward, 300);
    };

    return (
        <main className='min-h-screen bg-[#F6F9FF]'>
            <Hero onCtaClick={handleCtaClick} onProductsClick={scrollToProducts} />

            <MarqueeStrip />

            <section id={CAMPAIGN_REWARD_SECTION_ID} className='mx-auto w-full max-w-3xl scroll-mt-6 px-5 pt-14'>
                <Reveal>
                    <RewardCard isLoggedIn={isLoggedIn} onLoginRequest={handleCtaClick} onProductsClick={scrollToProducts} />
                </Reveal>
            </section>

            <HowItWorks />

            <div className='pt-16'>
                <BatteryProducts />
            </div>

            <CouponReminder isLoggedIn={isLoggedIn} onLoginRequest={handleCtaClick} />

            <Suspense fallback={null}>
                <SparePartsProducts />
            </Suspense>

            <InquiryTouchPoints />

            <WhyAzki />

            <FinalCta isLoggedIn={isLoggedIn} onCtaClick={handleCtaClick} onProductsClick={scrollToProducts} />

            <StickyMobileCta isLoggedIn={isLoggedIn} onCtaClick={handleCtaClick} onProductsClick={scrollToProducts} />

            {isLoginModalOpen && <LoginModal hasCloseButton onClose={() => setIsLoginModalOpen(false)} onUserLogin={handleUserLogin} />}
        </main>
    );
};

export default CampaignLanding;
